import React, { useEffect, useState } from "react";
import HeaderTitle from "../headerTitle";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import PageLoader from "../home/pageload";
import MetaTag from "../CommonSections/MetaTag";
import ImgSmartCity from "../../assest/images/IshanSmartCity.png";
import SubServiceSchema from "../CommonSections/subServicesSchema";
import JCNLForm from "./jcnlForm";

export default function JcnlBroadband() {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  const [smartCityData, setSmartCityData] = useState(null);
  const [settingResponse, setSettingResponse] = useState(null);

  useEffect(() => {
    const requestData = {
      service_tag: "smart_city",
    };

    axios
      .post(`${API_BASE_URL}/api/smartcity/getsmartCity`, requestData)
      .then((response) => {
        setSmartCityData(response);

        const generalSettingsData =
          response?.data?.data?.general_settings?.general_settings_data;

        const networkServicesSettingsData =
          generalSettingsData.find((item) => item.tag === "smart_city") || null;
        const networkServicesSettingsResponse = JSON.parse(
          networkServicesSettingsData?.response || "{}",
        );

        setSettingResponse(networkServicesSettingsResponse);
      })
      .catch((error) => {
        <PageLoader />;
      });
  }, []);

  const homeData = {
    data: {
      data: {
        general_settings: {
          general_settings_data: [
            {
              tag: "smart_city",
              response: "{}",
            },
            {
              tag: "other",
              response: "{}",
            },
          ],
        },

        smart_city: {
          metatag_info_data: [
            {
              title:
                " JCNL Broadband Service in Jharkhand - Ishan Technologies",
              description:
                "JCNL Broadband Service, a government-led initiative, provides reliable broadband connectivity to rural areas of Jharkhand supported by Ishan Technologies.",
            },
          ],

          smart_city_banner_data: [
            {
              id: 26,
              title: "High-Speed Broadband",
              banner_title: "Smart Urban Infrastructure for Connected Cities",
              banner_img_desc:
                "Powering 11+ smart cities in India making them smarter and safer with OFC, connectivity, command control, CCTV, smart lighting, and more.",
              button_img_name: "Contact Now",
              button_url:
                "https://ishantechnologies.com/contact/contact-for-sales",
              image_video:
                "https://ishantechnologies.com/api/static/87132smart_city_jpg.jpg",
              mobile_image:
                "https://ishantechnologies.com/api/static/78773web_image_375x466_d__2__jpg.jpg",
              is_image: "1",
              is_video: "0",
              created_at: "2023-09-28T10:53:30.000Z",
              updated_at: "2023-09-28T10:53:30.000Z",
            },
          ],

          smart_city_cta_banner_data: [
            {
              title: "Build Smarter Cities Today",
              button_text: "Get in Touch",
              button_url:
                "https://ishantechnologies.com/contact/contact-for-sales",
            },
          ],

          smart_city_information_data: [
            {
              id: 13,
              manage_services_id: 11,
              created_at: "2023-09-28T10:00:26.000Z",
              updated_at: "2024-02-03T01:47:04.000Z",
              description: `
                <div style="max-width:1200px; margin:auto; padding:10px 20px;">

                  <!-- TITLE ROW -->
                  <div style="display:flex; align-items:center; gap:16px; flex-wrap:wrap;">
                    <h2 style="
                      color:#00356f;
                      font-size:clamp(24px, 4vw, 36px);
                      margin:0;
                      line-height:1.2;
                      font-weight:600;
                    ">
                      Connecting Every Village of Jharkhand
                    </h2>
                  </div>

                  <!-- DESCRIPTION -->
                  <p style="
                    font-size:clamp(16px, 2vw, 18px);
                    line-height:1.7;
                    color:#555;
                    margin-top:20px;
                    max-width:950px;
                  ">
                    This initiative is a joint effort by the Government of Jharkhand,
                    Jharkhand Communication Network Limited (JCNL) and Ishan Technologies,
                    under the Digital Bharat Nidhi programme of the Department of
                    Telecommunications, Government of India.
                  </p>

                  <!-- CONTENT + IMAGE -->
                  <div style="
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    gap:clamp(24px, 4vw, 48px);
                    margin-top:40px;
                    flex-wrap:wrap;
                  ">

                    <!-- LEFT TEXT -->
                    <div style="flex:1 1 520px; min-width:280px;">
                      <h3 style="
                        color:#000;
                        font-size:clamp(18px, 2.5vw, 24px);
                        line-height:1.4;
                        margin-bottom:20px;
                        font-weight:600;
                      ">
                        Turn every rural village into a Digital Village
                      </h3>

                     <ul style="margin:0; padding:0; list-style:none; color:#555;">
                      <li style="
                        font-size:clamp(18px, 2vw, 18px);
                        color:#555;
                        margin-bottom:12px;
                        padding-left:22px;
                        text-indent:-22px;
                        line-height:1.6;
                      ">
                        • Empowers students with online education
                      </li>

                      <li style="
                        font-size:clamp(16px, 2vw, 18px);
                        color:#555;
                        margin-bottom:12px;
                        padding-left:22px;
                        text-indent:-22px;
                        line-height:1.6;
                      ">
                        • Helps local entrepreneurs, small businesses and self-help groups reach new markets
                      </li>

                      <li style="
                        font-size:clamp(16px, 2vw, 18px);
                        color:#555;
                        padding-left:22px;
                        text-indent:-22px;
                        line-height:1.6;
                      ">
                        • Enables easy access to e-governance, telemedicine and digital services
                      </li>
                    </ul>

                    </div>

                    <!-- RIGHT IMAGE -->
                    <div style="
                      flex:1 1 420px;
                      min-width:280px;
                      display:flex;
                      justify-content:center;
                      align-items:center;
                    ">
                      <img src="/images/jcnl/Group.png"
                          alt="JCNL Digital Village"
                          style="
                            width:100%;
                            max-width:420px;
                            height:auto;
                            object-fit:contain;
                          ">
                    </div>

                  </div>
                </div>
              `,
            },
          ],

          smart_city_advantages_data: [
            { title: "Scalable Infrastructure" },
            { title: "Secure Networks" },
            { title: "Smart Governance" },
            { title: "Energy Efficiency" },
            { title: "Citizen Safety" },
          ],

          smart_city_offer_data: [
            { title: "OFC Deployment" },
            { title: "Command & Control Centers" },
            { title: "Smart Surveillance" },
            { title: "Smart Lighting" },
            { title: "IoT Integration" },
          ],

          smart_city_services_faq_data: [],

          testimonial_info_data: [
            { name: "Client A", feedback: "Excellent smart city execution." },
            {
              name: "Client B",
              feedback: "Reliable and future-ready solutions.",
            },
          ],
        },
      },
    },
  };

  return (
    <>
      <style>{`
        /* Critical Form Input Fixes */
        .form-wrapper.banner-form * {
          box-sizing: border-box !important;
          padding: 5px;
        }

        .form-wrapper.banner-form input[type="text"],
        .form-wrapper.banner-form textarea,
        .form-wrapper.banner-form .form-control {
          box-sizing: border-box !important;
          padding: 10px 12px !important;
          width: 100% !important;
          min-height: 40px !important;
        }

        .form-wrapper.banner-form textarea {
          min-height: 80px !important;
          resize: vertical;
        }

        /* Ensure form is visible on all devices */
        .form-blk {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          position: relative !important;
          box-sizing: border-box !important;
        }

        /* Desktop view - side by side */
        @media (min-width: 961px) {
          .jcnl-offer-section .jcnl-offer-content {
            flex: 1 1 55% !important;
            max-width: 600px;
          }

          .jcnl-offer-section .form-blk {
            flex: 0 0 420px !important;
            max-width: 420px !important;
          }
        }

        /* Tablet view - start stacking */
        @media (max-width: 960px) {
          .jcnl-offer-section > div > div {
            flex-direction: column !important;
            align-items: stretch !important;
          }

          .jcnl-offer-section .jcnl-offer-content {
            flex: 1 1 100% !important;
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 !important;
          }

          .jcnl-offer-section .form-blk {
            flex: 1 1 100% !important;
            width: 100% !important;
            max-width: 100% !important;
            margin: 20px 0 0 0 !important;
          }

          /* Force form inputs to maintain padding */
          .form-wrapper.banner-form input[type="text"],
          .form-wrapper.banner-form textarea,
          .form-wrapper.banner-form .form-control {
            padding: 10px 12px !important;
          }
        }

        /* Mobile view */
        @media (max-width: 768px) {
          .empowering-right h2,
          .empowering-right h3 {
            font-size: clamp(20px, 5vw, 28px) !important;
          }

          .empowering-right img {
            width: 100% !important;
            height: auto !important;
            max-width: 100% !important;
            margin: 20px 0 !important;
          }

          .how-to-connect-section {
            padding: 30px 15px !important;
          }

          .how-to-connect-section h2 {
            font-size: clamp(28px, 8vw, 36px) !important;
          }

          .how-to-connect-section p {
            font-size: clamp(18px, 4vw, 22px) !important;
          }

          .how-to-connect-section img {
            width: clamp(45px, 10vw, 60px) !important;
          }
        }

        /* Extra small devices */
        @media (max-width: 480px) {
          .form-wrapper.banner-form {
            padding: 15px !important;
          }

          .form-wrapper.banner-form input[type="text"],
          .form-wrapper.banner-form textarea,
          .form-wrapper.banner-form .form-control {
            font-size: 16px !important;
            padding: 12px !important;
          }
        }

        /* Prevent image overflow */
        .empowering-right {
          overflow-x: hidden;
        }

        .empowering-right img {
          max-width: 100%;
          height: auto;
          object-fit: contain;
        }
      `}</style>

      {smartCityData === null ? (
        <PageLoader />
      ) : (
        <>
          <SubServiceSchema
            title={
              smartCityData?.data?.data?.smart_city?.smart_city_banner_data[0]
                .title
            }
            url="https://ishantechnologies.com/jcnlbroadband"
          />
          <MetaTag data={homeData} pageKey="smart_city" />
          <div className="page_heading responsive_heading">
            <div className="container">
              <HeaderTitle headerTitledata={homeData} pageKey="smart_city" />
            </div>
          </div>
          <div style={{ width: "100%", overflow: "hidden" }}>
            <img
              src="/images/jcnl/banner-JC.png"
              alt="JCNL Banner"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </div>

          <div className="empowering section-space spin-wrap">
            <div className="spin-round-wrap">
              <div className="spin-round color-navy-blue">
                <span className="ballDot1">1</span>
                <span className="ballDot2">2</span>
                <span className="ballDot3">3</span>
                <span className="ballDot4">4</span>
              </div>
            </div>

            <div className="container">
              <div className="empowering-inner">
                <div className="empowering-left">
                  <img
                    src={ImgSmartCity}
                    alt="Smart City"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                    }}
                    loading="lazy"
                  />
                </div>
                <div
                  className="empowering-right"
                  dangerouslySetInnerHTML={{
                    __html:
                      homeData?.data?.data?.smart_city
                        ?.smart_city_information_data[0]?.description,
                  }}
                ></div>
              </div>
            </div>

            <div className="spin-round-wrap">
              <div className="spin-round">
                <span className="ballDot1">1</span>
                <span className="ballDot2">2</span>
                <span className="ballDot3">3</span>
                <span className="ballDot4">4</span>
              </div>
            </div>
          </div>

          {/* Special Launch Offer Section - Mobile Optimized */}
          <div className="supercharge supercharge-left jcnl-offer-section">
            <div className="container">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "stretch",
                  gap: "24px",
                  flexWrap: "wrap",
                }}
              >
                {/* Text Content */}
                <div
                  className="jcnl-offer-content"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    flex: "1 1 55%",
                    minWidth: "280px",
                    paddingTop: "32px", // 🔥 moves text down
                  }}
                >
                  <h1
                    style={{
                      color: "#2eb1e8",
                      fontWeight: "600",
                      fontSize: "clamp(24px, 4vw, 36px)",
                      lineHeight: "1.3",
                      margin: "0",
                    }}
                  >
                    Special Launch Offer
                  </h1>

                  <p
                    style={{
                      fontSize: "clamp(16px, 2.5vw, 20px)",
                      lineHeight: "1.6", // 🔥 better readability
                      color: "white",
                      maxWidth: "600px",
                      margin: "0",
                      marginTop: "20px",
                    }}
                  >
                    Affordable, high-speed broadband for rural homes and
                    communities.
                  </p>

                  <p
                    style={{
                      fontSize: "clamp(28px, 6vw, 60px)",
                      lineHeight: "1.2", // 🔥 more breathing space
                      color: "white",
                      maxWidth: "600px",
                      fontWeight: "700",
                      margin: "0",
                      marginTop: "20px",
                    }}
                  >
                    First year 10Mbps absolutely free!
                  </p>
                </div>

                {/* Form Block - Force Visibility */}
                <div
                  className="form-blk"
                  style={{
                    flex: "0 0 420px",
                    maxWidth: "420px",
                    minWidth: "280px",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    zIndex: "10",
                  }}
                >
                  <JCNLForm
                    pageName="unifiedCommunicationData"
                    planDetails="Plan 10 Mbps"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* How to Connect Section - Responsive */}
          <section
            className="how-to-connect-section"
            style={{
              background: "#ffffff",
              padding: "40px 20px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                maxWidth: "1200px",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "40px",
                flexWrap: "wrap",
              }}
            >
              {/* Left */}
              <div style={{ flex: "1 1 260px", minWidth: "200px" }}>
                <p
                  style={{
                    fontSize: "clamp(24px, 2vw, 36px)",
                    color: "#0b3c6f",
                    marginBottom: "4px",
                    fontWeight: "600",
                  }}
                >
                  How to
                </p>
                <h2
                  style={{
                    // fontSize: "clamp(32px, 5vw, 48px)",
                    fontSize: "clamp(24px, 2vw, 36px)",
                    fontWeight: "700",
                    color: "#0b3c6f",
                    margin: 0,
                    textTransform: "lowercase",
                  }}
                >
                  connect
                </h2>
              </div>

              {/* Right */}
              <div style={{ flex: "1 1 280px", minWidth: "250px" }}>
                {[
                  {
                    icon: "/images/jcnl/icons/icon1.png",
                    text: "Share your village name and contact details",
                  },
                  {
                    icon: "/images/jcnl/icons/icon2.png",
                    text: (
                      <>
                        Our <strong>JCNL–Ishan</strong> team will visit for
                        installation and setup
                      </>
                    ),
                  },
                  {
                    icon: "/images/jcnl/icons/icon3.png",
                    text: "Enjoy your free 10 Mbps connection for the first year",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      marginBottom: index < 2 ? "16px" : "0",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={`Step ${index + 1}`}
                      style={{
                        width: "clamp(45px, 8vw, 60px)",
                        height: "auto",
                        flexShrink: 0,
                        objectFit: "contain",
                      }}
                    />
                    <p
                      style={{
                        fontSize: "clamp(13px, 2vw, 24px)",
                        color: "#444444c9",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <br />
          <div className="supercharge supercharge-left">
            <div className="container">
              <h2
                className="supercharge-heading"
                style={{
                  fontSize: "clamp(20px, 4vw, 32px)",
                }}
              >
                {"Supercharge your connectivity with Ishan Technologies"}
              </h2>
            </div>
          </div>
        </>
      )}
    </>
  );
}
